import React, { useState } from 'react';
import { Button, Typography, Grid } from '@mui/material';
import SupplierForm from './SupplierForm';
import FormInstructionBox from '../components/FormInstructionBox';


export default function SupplierFormView({ data,updateData, handleNext }) {
  const [editing, setEditing] = useState(false);
 const [supplierData, setSupplierData] = useState({
    supplierName: '',
    email: '',
    phone: '',
    contactPerson: '',
    gstNumber: '',
    panNumber: '',
    website: '',
    companyType: '',
    addresses: [], 
    certificates: [],
    warehouses: [],
  });

  const handleEdit = () => setEditing(true);


  const handleSaveAndNext = () => {
    console.log("inside vide handlesavenext");
    setEditing(false);
    data = updateData;
   // handleSubmit(); // if needed in the stepper
  };
  
  const supplierInstructions = [
        "The **Supplier Name** field is read-only and unique across all supplier profiles. To edit the  supplier name, please contact the System Administrator.WhatsApp or Phone: +91 999 464 1128",
        "The **Email Address** field is read-only must be unique across all supplier profiles.",
        "The **Phone Number** field is  read-only must be unique across all supplier profiles",
        "The **Company Type** is mandatory. Please select the appropriate Company Type",
        "Click 'Edit and Update' to apply changes, or 'Cancel' to discard."
    ];

  return (
    <div>
      {!editing ? (
        <>
          <Typography variant="h6" gutterBottom>Supplier Details</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}><strong>Supplier Name:</strong> {data.supplierName}</Grid>
            <Grid item xs={6}><strong>Email:</strong> {data.email}</Grid>
            <Grid item xs={6}><strong>Phone:</strong> {data.phone}</Grid>
            <Grid item xs={6}><strong>Contact Person:</strong> {data.contactPerson}</Grid>
            <Grid item xs={6}><strong>GST Number:</strong> {data.gstNumber}</Grid>
            <Grid item xs={6}><strong>PAN Number:</strong> {data.panNumber}</Grid>
            <Grid item xs={6}><strong>Website:</strong> {data.website}</Grid>
            <Grid item xs={6}><strong>Company Type:</strong> {data.companyType?.typeName}</Grid>
          </Grid>
         {/*<Button variant="contained" onClick={handleEdit} sx={{ mt: 2 }}>
            Edit
          </Button> */}
        </>
      ) : (
        <SupplierForm
          data={data}
          updateData={updateData}
          handleNext={handleSaveAndNext}
        />
      )}
             <FormInstructionBox 
                instructions={supplierInstructions} 
                title="Supplier Details Guidelines" 
            />
                  
    </div>
  );
}
